var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell",class:_vm.cellClass,on:{"click":_vm.onClick}},[_c('div',{staticClass:"toprow"},[_c('span',{staticClass:"dn tnum"},[_vm._v(_vm._s(_vm.dayNum))]),(_vm.showDot)?_c('span',{staticClass:"sdot"}):_vm._e()]),(_vm.chip)?_c('span',{staticClass:"chiptag"},[_vm._v(_vm._s(_vm.chip))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }